import { useState, useEffect } from "react";
import * as React from 'react';
import {
    Box, Grid, Divider, Autocomplete,
    Stack, Typography, Button, Tooltip, IconButton, TextField, CardContent, useTheme,
    ToggleButtonGroup,
    ToggleButton,


} from "@mui/material";

import ReportsHeader from "../../../components/ReportHeader";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import jsPDF from 'jspdf';
import { useRef } from "react";
import DownloadIcon from '@mui/icons-material/Download';
import CallAlertBar from "../../../Layout/Alertbar";
import 'dayjs/plugin/customParseFormat';

import QCReportView from "./QCReportView";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import { DownloadOutlined, PictureAsPdfOutlined, PrintOutlined, Save, } from "@mui/icons-material";
import useIndentInvoiceNoList from "../../../hooks/useIndentInvoiceNoList";
import useInvoiceNoCRUD from "../../../hooks/useInvoiceNoCRUD";
import { Production_API_ENDPOINTS } from "../../../config/api/apiCallProduction";
import useAllInvoiceNoList from "../../../hooks/useAllInvoiceNoList";
import useIndentNoListByInvoiceNo from "../../../hooks/useIndentNoListByInvoiceNo";
import AddQCPropertyMaster from "../../master/AddQCPropertyMaster";
import CustomTableContainer from "../../../components/table/CustomTableContainer";

import { toast } from "react-toastify";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";


const GenerateQCDataByFilterData = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    // Fallback colors in case tokens are undefined
    // const primaryColor = colors?.primary?.[500] || '#1976d2';  // Default blue if undefined
    // const secondaryColor = colors?.secondary?.[500] || '#5293fa';  // Default red if undefined

    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const [invoiceOptions] = useState([]);

    const [viewInvoiceNoList, setViewInvoiceNoList] = useState(false);

    const [viewIndentNoList, setViewIndentNoList] = useState(false);
    const [visiblebtnUpdateInvoiceNo, setVisiblebtnUpdateInvoiceNo] = useState(false);
    const [isDataLoaded] = useState(false);
    const [reportbtndisabled, setReportbtndisabled] = useState(false);
    const [qcpropertylist, setQCPropertyList] = useState([]);
    const [viewPropertymaster, setViewPropertymaster] = useState(false);
    const [allqcdetails, setAllQCDetails] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [filters, setFilters] = useState({
        pr_number: '',
        release_no: '',
        // email: '',
        // workphone: '',
        status: '',
        // payales: '',
    });

    const callMessage = (severity, message, title) => {
        setParentRollSeverityvalue(severity);
        setParentRollMessageValue(message);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [qcExistingdata, setQcExistingdata] = useState([]);

    const filteredData = qcExistingdata.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All') {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });
    const rows = filteredData.map((row, index) => ({
        id: row.id ?? index + 1,
        ...row,
    }));

    const columnsExisting = [
        { field: 'date', headerName: 'PRODUCTION DATE', width: 150 },
        { field: 'jumbono', headerName: 'JUMBO NO', width: 120 },
        { field: 'quality', headerName: 'QUALITY', width: 120 },
        { field: 'ordergsm', headerName: 'ORDER GSM', width: 120 },
        { field: 'avggsm', headerName: 'AVG GSM', width: 120 },
        { field: 'calipermicron', headerName: 'CALIPER (micron)', width: 150 },
        { field: 'bulkccpergm', headerName: 'BULK (cc/gm)', width: 140 },
        { field: 'stiffnessmd', headerName: 'STIFFNESS MD (mN)', width: 160 },
        { field: 'stiffnesscd', headerName: 'STIFFNESS CD (mN)', width: 160 },
        { field: 'stiffnessgm', headerName: 'STIFFNESS GM (mN)', width: 160 },
        { field: 'ratio', headerName: 'RATIO', width: 100 },
        { field: 'cobbtop', headerName: 'COBB TOP', width: 120 },
        { field: 'cobbback', headerName: 'COBB BACK', width: 120 },
        { field: 'plybond', headerName: 'PLYBOND (J/m2)', width: 150 },
        { field: 'igtdrypick', headerName: 'IGT DRY PICK (m/sec)', width: 170 },
        { field: 'roughnesspps', headerName: 'ROUGHNESS PPS (um)', width: 170 },
        { field: 'gloss', headerName: 'GLOSS (%)', width: 120 },
        { field: 'moisture', headerName: 'MOISTURE (%)', width: 130 },
        { field: 'brightness', headerName: 'BRIGHTNESS (%)', width: 150 },
        { field: 'backbrightness', headerName: 'BACK BRIGHTNESS (%)', width: 180 },
    ];

    const { invoiceNoList, loadInvoiceNoByID, selectedInvoiceNo, setSelectedInvoiceNo, } = useIndentInvoiceNoList();
    const { allInvoiceNoList, selectedAllInvoiceNo, setSelectedAllInvoiceNo, setSelectedAllInvoiceNoID } = useAllInvoiceNoList();
    const { filteredIndentNoList, loadIndentNoByID, selectedIndentNo, setSelectedIndentNo, setSelectedIndentNoID } = useIndentNoListByInvoiceNo();


    const { processInvoice } = useInvoiceNoCRUD(callMessage);

    const [indentno, setIndentno] = useState('');

    const [transferOrderNo, setTransferOrderNo] = useState('');
    const [isAutoSet, setIsAutoSet] = useState(false);

    const linkInvoiceNoToIndentNo = async () => {
        // Validation before making API call
        if (!indentno?.indent_no || indentno.indent_no.trim() === "") {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue('Indent No. is required!');
            setParentRollAlertTitleValue('Validation');
            setParentRollMsgOpen(true);
            return;
        }

        if (!selectedInvoiceNo || selectedInvoiceNo.trim() === "") {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue('Invoice No. is required!');
            setParentRollAlertTitleValue('Validation');
            setParentRollMsgOpen(true);
            return;
        }

        const requestBody = {
            indent_no: indentno.indent_no,
            invoice_no: selectedInvoiceNo,
            created_by: localStorage.getItem('userID'),
            transferorderno: transferOrderNo

        }



        await processInvoice(requestBody);

        console.log("Invoice linked successfully");

        setReportbtndisabled(false);

    }

    const [selectedOption, setSelectedOption] = useState('order'); // Default to "Order"



    const [indentNoList, setIndentNoList] = useState([]);
    const [viewReport, setViewReport] = useState(false);
    const [parentRoll, setparentRoll] = useState([]);

    const reportRef = useRef();
    const [allQCData, setAllQCData] = useState({});
    const [selectedParentRoll, setSelectedParentRoll] = useState();


    const [viewJumboRollNo, setViewJumboRollNo] = useState(false);

    const filteredDataExisting = allqcdetails.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const generatePDF = () => {
        setViewReport(true);

    };



    const handleDownloadPdf = () => {

        if (viewReport) {
            generatePDF();

            const doc = new jsPDF({
                format: 'a4',
                unit: 'pt'
            });

            doc.html(reportRef.current, {
                callback: function (doc) {
                    doc.save('JumboQCTestCertificate.pdf');
                },
                x: 10,
                y: 10,
                width: 575, // A4 page width - margins
                windowWidth: 800, // The window width to use for rendering
            });

        }

    };

    const handlePrint = () => {
        if (reportRef.current) {
            const printContents = reportRef.current.innerHTML;
            const printWindow = window.open('', '_blank',);

            printWindow.document.write(`
      <html>
        <head>
          <title>Print Preview</title>
          <style>
            body { font-family: Arial, sans-serif; color: black; font-size: 10pt; background-color: white; }
            table { border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; font-size: 10pt; }
            th, td { border: 1px solid black; padding: 4px;  font-family: Arial, sans-serif; font-size: 10pt;}
            /* Add any additional styles from your component */
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);

            printWindow.document.close();
            printWindow.focus();

            printWindow.onload = () => {
                printWindow.print();
                // Optionally close window after printing
                // printWindow.close();
            };
        }
    };





    const getCertificateDetails = (value) => {

        const para = {
            p_jumbo_roll_code: value.pr_number,
        }

        callApi(API_ENDPOINTS.PRODUCTION_GET_QC_CERTIFICATE_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                // Update state with fetched data
                if (data.length > 0) {
                    const formData = {
                        consigneename: data[0].consigneename, // Update as per your requirement
                        dealername: data[0].dealername,
                        itemcode: data[0].item_code,
                        gsm: data[0].gsm,
                        size: data[0].size,
                        indentno: data[0].indent_no,
                        line_no: data[0].line_no,
                        caliper: data[0].calipermicron,
                        avggsm: data[0].avggsm,
                        bulkccpergm: data[0].bulkccpergm,
                        stiffnessmd: data[0].stiffnessmd,
                        stiffnesscd: data[0].stiffnesscd,
                        stiffnessgm: data[0].stiffnessgm,
                        ratio: data[0].ratio,
                        cobbtop: data[0].cobbtop,
                        cobbback: data[0].cobbback,
                        plybond: data[0].plybond,
                        igtdrypick: data[0].igtdrypick,
                        roughnesspps: data[0].roughnesspps,
                        moisture: data[0].moisture,
                        brightness: data[0].brightness,
                        gloss: data[0].gloss,
                        backbrightness: data[0].backbrightness,

                    };

                    setAllQCData(formData);
                    generatePDF();
                    setParentRollMsgOpen(false);
                }
                else {
                    setAllQCData([]);
                    setViewReport(false);


                    setParentRollSeverityvalue('info');
                    setParentRollMessageValue('No Certificate details found for the jumbo.!');
                    setParentRollAlertTitleValue('Info');
                    setParentRollMsgOpen(true);
                }


            })
            .catch(error => {
                // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue(error.message);
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);


            });
    }

    const getCertificateDetailsByIndentNo = () => {
        // Validation before making API call
        let indent_no;
        let invoice_no;
        if (selectedOption === 'order') {

            indent_no = indentno?.indent_no;
            invoice_no = selectedInvoiceNo;

        }
        else {
            indent_no = selectedIndentNo?.indent_no;
            invoice_no = selectedAllInvoiceNo.invoice_no;
        }

        if (!indent_no || indent_no.trim() === "") {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue('Indent No. is required!');
            setParentRollAlertTitleValue('Validation');
            setParentRollMsgOpen(true);
            return;
        }

        if (!invoice_no || invoice_no.trim() === "") {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue('Invoice No. is required!');
            setParentRollAlertTitleValue('Validation');
            setParentRollMsgOpen(true);
            return;
        }


        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_indent_no: indent_no,
        }

        callApi(Production_API_ENDPOINTS.PRODUCTION_GET_QC_CERTIFICATE_DETAILS_BY_ORDERNO, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                // Update state with fetched data
                if (data.length > 0) {
                    const qcData = JSON.parse(data[0].qc_data);

                    const qcAvg = qcData.qc_avg || {};
                    const qcSpec = qcData.qc_spec || {};

                    const formData = {
                        consigneename: data[0].consigneename,
                        dealername: data[0].dealername,
                        itemcode: data[0].item_code,
                        gsm: data[0].gsm,
                        size: data[0].size,
                        indentno: data[0].indent_no,
                        line_no: data[0].line_no,
                        invoiceno: invoice_no,
                        transferorderno: transferOrderNo,

                        // From qc_avg
                        caliper: qcAvg.caliper_micron,
                        avggsm: qcAvg.avg_gsm,
                        bulkccpergm: qcAvg.bulk_cc_per_gm,
                        stiffnessmd: qcAvg.stiffness_md,
                        stiffnesscd: qcAvg.stiffness_cd,
                        stiffnessgm: qcAvg.stiffness_gm,
                        ratio: qcAvg.ratio,
                        cobbtop: qcAvg.cobb_top,
                        cobbback: qcAvg.cobb_back,
                        plybond: qcAvg.plybond,
                        igtdrypick: qcAvg.igt_dry_pick,
                        roughnesspps: qcAvg.roughness_pps,
                        moisture: qcAvg.moisture,
                        brightness: qcAvg.brightness,
                        gloss: qcAvg.gloss,
                        back_brightness: qcAvg.back_brightness,

                        // From qc_spec
                        spec_caliper: qcSpec.caliper_micron,
                        spec_avggsm: qcSpec.avg_gsm,
                        spec_bulkccpergm: qcSpec.bulk_cc_per_gm,
                        spec_stiffnessmd: qcSpec.stiffness_md,
                        spec_stiffnesscd: qcSpec.stiffness_cd,
                        spec_stiffnessgm: qcSpec.stiffness_gm,
                        spec_ratio: qcSpec.ratio,
                        spec_cobbtop: qcSpec.cobb_top,
                        spec_cobbback: qcSpec.cobb_back,
                        spec_plybond: qcSpec.plybond,
                        spec_igtdrypick: qcSpec.igt_dry_pick,
                        spec_roughnesspps: qcSpec.roughness_pps,
                        spec_moisture: qcSpec.moisture,
                        spec_brightness: qcSpec.brightness,
                        spec_gloss: qcSpec.gloss,
                        spec_backbrightness: qcSpec.back_brightness,
                    };




                    setAllQCData(formData);
                    generatePDF();
                    setParentRollMsgOpen(false);

                    getAllQualityCertificateDetailsByIndentNo(indent_no);
                }
                else {
                    setAllQCData([]);
                    setViewReport(false);

                    setParentRollSeverityvalue('info');
                    setParentRollMessageValue('No Certificate details found for the jumbo.!');
                    setParentRollAlertTitleValue('Info');
                    setParentRollMsgOpen(true);

                    setAllQCDetails([]);
                }
            })
            .catch(error => {
                // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue(error.message);
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
            });
    }

    const getAllQualityCertificateDetailsByIndentNo = (indent_no) => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_indent_no: indent_no,
        }

        callApi(API_ENDPOINTS.PRODUCTION_GetALLQualityCertificateDetailsByOrderNo, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                // Update state with fetched data
                if (data.length > 0) {
                    setAllQCDetails(data);

                    const requiredFields = [
                        "date", "jumbono", "quality", "ordergsm", "avggsm", "calipermicron",
                        "bulkccpergm", "stiffnessmd", "stiffnesscd", "stiffnessgm",
                        "ratio", "cobbtop", "cobbback", "plybond", "igtdrypick",
                        "roughnesspps", "gloss", "moisture", "brightness"
                    ];

                    const hasMissingValues = data.some(jumbo =>
                        requiredFields.some(field => jumbo[field] === null || jumbo[field] === undefined)
                    );


                    if (hasMissingValues) {
                        // setParentRollSeverityvalue('warning');
                        // setParentRollMessageValue('Some QC details are missing or incomplete for one or more jumbos.');
                        // setParentRollAlertTitleValue('Warning');
                        // setParentRollMsgOpen(true);

                        setQcExistingdata(data);

                        toast.warn('Some QC details are missing or incomplete for one or more jumbos.', {
                            position: toast.POSITION.BOTTOM_RIGHT,

                        });
                        setReportbtndisabled(true);
                        setValue('2');

                    }
                    else {
                        setReportbtndisabled(false);
                        setQcExistingdata([]);
                        setValue('1');

                    }

                }
                else {
                    setAllQCDetails([]);
                }
            })
            .catch(error => {
                // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue(error.message);
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
            });

    }



    const handleParentRollNoChangeChange = (event, value) => {

        if (value !== null && value !== undefined) {
            setSelectedParentRoll(value);
            getCertificateDetails(value);
        }



    }



    const filterProductType = (filter) => {
        setSelectedOption(filter);
        setViewJumboRollNo(false);
        setViewReport(false);
    };


    const handleIndentNoChange = (event, value) => {
        if (value !== undefined && value != null) {
            setIndentno(value);
            loadInvoiceNoByID(value.indent_no);
            setViewInvoiceNoList(true);
            setSelectedInvoiceNo('');
            setTransferOrderNo('');
        }
        else {
            setIndentno('');
            setViewInvoiceNoList(false);
            setTransferOrderNo('');
        }
    }


    const handleAllInvoiceNoChange = (event, value) => {
        if (value !== undefined && value != null) {
            setSelectedAllInvoiceNo(value);
            setSelectedAllInvoiceNoID(value.id);
            setViewIndentNoList(true);
            setSelectedIndentNoID(null);
            setSelectedIndentNo(null);
            setSelectedIndentNo('');
            loadIndentNoByID(value.invoice_no);
            setTransferOrderNo('');
        }
        else {
            setSelectedAllInvoiceNo(null);
            setSelectedAllInvoiceNoID(null);

            setViewIndentNoList(false);
            loadIndentNoByID('');
            setSelectedIndentNoID(null);
            setSelectedIndentNo(null);
            setSelectedIndentNo('');
            setTransferOrderNo('');
        }
    }
    const handleFilterIndentNoChange = (event, value) => {
        if (value !== null && value !== undefined) {
            setSelectedIndentNo(value);
            // 👇 Optional: trigger further processing if needed
            processInvoiceSelection(value.indent_no, selectedAllInvoiceNo.invoice_id);
        }
        else {
            setSelectedIndentNo(null);
            setTransferOrderNo('');
        }
    }


    const fetchIndentNo = async () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 0,
        }

        try {
            const data = await callApi(API_ENDPOINTS.REPORT_GetProductionDistinctOrderNoForConversionReport, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data?.length > 0) {
                setIndentNoList(data);
            }
        }
        catch (error) {
            alert(error);
        }
    }


    useEffect(() => {
        fetchIndentNo();
    }, [])

    const handleFilterClick = (filter) => {
        filterProductType(filter);
        setSelectedOption(filter);



        if (filter === 'invoice') {
            loadInvoiceNoByID(null);
            setVisiblebtnUpdateInvoiceNo(true);
        }
        else {
            setVisiblebtnUpdateInvoiceNo(false);
        }



    };

    const LoadQCPropertyList = () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
        }
        callApi(Production_API_ENDPOINTS.getMasterQCPropertyList, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setQCPropertyList(data);
                }
            })
            .catch(error => {
                // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue(error.message);
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
                // 

            });
    }

    useEffect(() => {
        if (!isDataLoaded) {
            LoadQCPropertyList();
        }
    }, [isDataLoaded]);


    const handlePropertyMasterOpenClose = () => {
        setViewPropertymaster(false);

    }
    const handleInvoiceChange = (event, newValue) => {
        const selectedValue = typeof newValue === 'string'
            ? newValue
            : newValue?.invoice_no || '';

        setSelectedInvoiceNo(selectedValue);

        // Safely access invoice_id only if newValue is not null
        const invoiceId = newValue?.invoice_id || null;

        // Optional: trigger further processing if needed, pass null or valid invoice_id
        processInvoiceSelection(indentno.indent_no, invoiceId);
    };


    const processInvoiceSelection = async (indentno, invoice_id) => {
        if (!indentno || !invoice_id) {
            setTransferOrderNo('');
            return;
        }

        const para = {
            indent_no: indentno,
            invoice_id: invoice_id
        }

        try {
            const data = await callApi(Production_API_ENDPOINTS.GetManualIndentNoByIndentAndInvoiceNo, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data?.length > 0) {
                setTransferOrderNo(data[0].transferorderno || '');
            }
            else {
                setTransferOrderNo('');
            }
        }
        catch (error) {
            alert(error);
        }

    };



    return (

        <Box style={{ backgroundColor: "transparent", height: '620px' }}>
            <Box flexDirection={'row'} p={'5px'}>
                <ReportsHeader title={'Generate Quality Certificate'} subtitle="" callback={handleBackWinderMachineEntry} />
            </Box>

            <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

            <Divider sx={{ mb: 0 }} />

            <CardContent >

                <Box display="flex" flexDirection={'column'} >
                    <Box  >
                        {/* Top Filter Row */}
                        <Stack direction="row" alignItems="center" spacing={1}>


                            <ToggleButtonGroup
                                value={selectedOption}
                                exclusive
                                onChange={(e, val) => val && handleFilterClick(val)}
                                size="small"
                                sx={{
                                    borderRadius: 999,
                                    boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                                    overflow: "hidden",
                                }}
                            >
                                <ToggleButton
                                    value="order"
                                    sx={{
                                        textTransform: "none",
                                        fontWeight: 500,
                                        fontSize: "0.70rem",      // smaller font
                                        px: 1.5,                   // less padding
                                        py: 0.25,                  // less height
                                        gap: 0.5,
                                        "& .MuiSvgIcon-root": { fontSize: 16 }, // smaller icon
                                        "&.Mui-selected": {
                                            background: "linear-gradient(135deg, #1189ecff, #1189ecff)",
                                            color: "#fff",
                                        },
                                        "&:hover": {
                                            backgroundColor: "rgba(66, 165, 245, 0.1)",
                                        },
                                    }}
                                >
                                    {/* <Receipt fontSize="inherit" /> */}
                                    Order No
                                </ToggleButton>

                                <ToggleButton
                                    value="invoice"
                                    sx={{
                                        textTransform: "none",
                                        fontWeight: 500,
                                        fontSize: "0.70rem",
                                        px: 1.5,
                                        py: 0.25,
                                        gap: 0.5,
                                        "& .MuiSvgIcon-root": { fontSize: 16 },
                                        "&.Mui-selected": {
                                            background: "linear-gradient(135deg, #1189ecff, #1189ecff)",
                                            color: "#fff",
                                        },
                                        "&:hover": {
                                            backgroundColor: "rgba(66, 165, 245, 0.1)",
                                        },
                                    }}
                                >
                                    {/* <Description fontSize="inherit" /> */}
                                    Invoice No
                                </ToggleButton>
                            </ToggleButtonGroup>


                            {selectedOption === "order" ? (
                                <>
                                    <Autocomplete
                                        sx={{
                                            width: `${Math.min(
                                                Math.max(
                                                    (Math.max(...invoiceOptions.map(opt => String(opt).length)) + 2) * 8,
                                                    180 // min px
                                                ),
                                                400 // max px
                                            )}px`
                                        }}
                                        size="small"
                                        value={indentno}
                                        onChange={handleIndentNoChange}
                                        options={indentNoList}
                                        getOptionLabel={(option) =>
                                            option?.indent_no ? `${option.indent_no}` : ""
                                        }
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Order No" color="secondary" size="small" variant="outlined" />
                                        )}
                                    />

                                    {viewInvoiceNoList && (
                                        <>
                                            <Autocomplete
                                                fullWidth
                                                freeSolo
                                                sx={{
                                                    width: `${Math.min(
                                                        Math.max(
                                                            (Math.max(...invoiceNoList.map(opt => opt.invoice_no?.length || 0)) + 2) * 8,
                                                            180 // min px
                                                        ),
                                                        400 // max px
                                                    )}px`
                                                }}
                                                // size="small"
                                                options={invoiceNoList}
                                                getOptionLabel={(option) => typeof option === 'string' ? option : option.invoice_no} // <-- FIX
                                                value={selectedInvoiceNo}
                                                onChange={handleInvoiceChange}  // <-- handled externally now
                                                // onInputChange={(event, newInputValue) => setSelectedInvoiceNo(newInputValue)}

                                                onInputChange={(event, newInputValue) => {
                                                    setSelectedInvoiceNo(newInputValue);

                                                    // check if the typed value exists in the list
                                                    const exists = invoiceNoList.some(
                                                        (opt) =>
                                                            (typeof opt === 'string' ? opt : opt.invoice_no) === newInputValue
                                                    );

                                                    // disable report if user types a new one not in the list
                                                    setReportbtndisabled(!exists && newInputValue.trim() !== '');
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} color="secondary" size="small" label="Select or type invoice no" variant="outlined" />
                                                )}
                                            />

                                            <TextField
                                                label="Transfer Order No"
                                                color="secondary"
                                                size="small"
                                                variant="outlined"
                                                value={transferOrderNo}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setTransferOrderNo(newValue);

                                                    if (isAutoSet) {
                                                        // first change after auto-fill, so check if user modified it
                                                        setIsAutoSet(false); // reset flag so we can detect manual edits later
                                                    } else {
                                                        // user is manually editing, disable the button
                                                        setReportbtndisabled(true);
                                                    }
                                                }}
                                            />

                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <Autocomplete
                                        fullWidth
                                        // freeSolo
                                        sx={{
                                            width: `${Math.min(
                                                Math.max(
                                                    (Math.max(...invoiceNoList.map(opt => opt.invoice_no?.length || 0)) + 2) * 8,
                                                    180 // min px
                                                ),
                                                400 // max px
                                            )}px`
                                        }}
                                        size="small"
                                        options={allInvoiceNoList}
                                        getOptionLabel={(option) => typeof option === 'string' ? option : option.invoice_no} // <-- FIX
                                        value={selectedAllInvoiceNo}
                                        // onChange={(event, newValue) => {

                                        //     setSelectedAllInvoiceNo(typeof newValue === 'string' ? newValue : newValue?.invoice_no || '');
                                        // }}

                                        onChange={handleAllInvoiceNoChange}
                                        // onInputChange={(event, newInputValue) => setSelectedAllInvoiceNo(newInputValue)}
                                        renderInput={(params) => (
                                            <TextField {...params} color="secondary" size="small" label="Select Invoice No" variant="outlined" />
                                        )}
                                    />

                                    {viewIndentNoList && (
                                        <>
                                            <Autocomplete
                                                sx={{
                                                    width: `${Math.min(
                                                        Math.max(
                                                            (Math.max(...filteredIndentNoList.map(opt => String(opt).length)) + 2) * 8,
                                                            180 // min px
                                                        ),
                                                        400 // max px
                                                    )}px`
                                                }}
                                                size="small"
                                                value={selectedIndentNo}
                                                onChange={handleFilterIndentNoChange}
                                                options={filteredIndentNoList}
                                                getOptionLabel={(option) =>
                                                    option?.indent_no ? `${option.indent_no}` : ""
                                                }
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Select Order No" color="secondary" size="small" variant="outlined" />
                                                )}
                                            />

                                            <TextField
                                                label="Transfer Order No"
                                                color="secondary"
                                                size="small"
                                                variant="outlined"
                                                value={transferOrderNo}
                                                onChange={(e) => setTransferOrderNo(e.target.value)}
                                            />
                                        </>
                                    )}

                                </>
                            )}

                            <Tooltip title="Link Invoice No to Order No">
                                <IconButton
                                    color="secondary"
                                    size="small"
                                    onClick={linkInvoiceNoToIndentNo}
                                    disabled={visiblebtnUpdateInvoiceNo}
                                >
                                    <Save />
                                </IconButton>
                            </Tooltip>

                            <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                startIcon={<PictureAsPdfOutlined />}
                                onClick={() => { getCertificateDetailsByIndentNo(); }} //filterQCDetailsbyfilteredinput(); 
                                sx={{ whiteSpace: "nowrap" }}
                                disabled={reportbtndisabled}
                            >
                                Report
                            </Button>




                            {/* <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                startIcon={<Settings />}
                                onClick={() => setViewPropertymaster(true)}
                                sx={{ whiteSpace: "nowrap" }}
                            >
                                QC Attributes
                            </Button> */}
                        </Stack>
                    </Box>

                </Box>
            </CardContent>

            <Divider sx={{ marginTop: 0, }} />

            <CardContent sx={{ paddingTop: 0.5 }}>
                <Box display="flex" flexDirection={'column'}>



                    {viewJumboRollNo && (

                        <Box mt='8px' display="flex" justifyContent={'space-between'}>
                            <Grid container spacing={1} justifyContent="start" style={{ marginTop: '0px' }}>
                                <Grid item >
                                    <Typography ml={0} style={{ fontSize: '14px' }}> Jumbo Roll No :</Typography>
                                </Grid>

                                <Grid item lg={3} xs={4} xl={3}>
                                    <Autocomplete
                                        fullWidth
                                        size="small"
                                        id="mo-autocomplete"
                                        options={parentRoll}
                                        value={selectedParentRoll}
                                        onChange={handleParentRollNoChangeChange}
                                        getOptionLabel={(option) => `${option.pr_number}`} // Assuming lot numbers are strings
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                label="Select Jumbo Roll No"
                                                placeholder="Select Jumbo Roll No"
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item lg={3} xs={4} xl={3}>
                                    <IconButton onClick={handleDownloadPdf} >
                                        <DownloadIcon color="success" />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    {viewReport && (
                        <>
                            <Box sx={{ width: "100%", typography: "body1", }}>
                                <TabContext value={value}>
                                    <Box
                                        sx={{
                                            borderBottom: 1,
                                            borderColor: (theme) =>
                                                theme.palette.mode === "dark" ? "grey.700" : "divider",
                                            // p: 0,
                                            // m: 0,
                                        }}
                                    >
                                        <TabList
                                            onChange={handleChange}
                                            aria-label="example tabs"
                                            textColor="inherit"
                                            indicatorColor="secondary"
                                            sx={{
                                                minHeight: "unset",
                                                //   p: 0,
                                                //   m: 0,
                                                "& .MuiTab-root": {
                                                    minHeight: "unset",
                                                    fontSize: "0.875rem",
                                                },
                                            }}
                                        >
                                            <Tab label="QC Report" value="1" sx={{ color: "text.primary" }} />
                                            <Tab label="Missing Jumbo QC Details" value="2" sx={{ color: "text.primary" }} />

                                        </TabList>
                                    </Box>
                                    <TabPanel value="1" sx={{ color: "text.primary", p: 0, m: 0 }}>
                                        <Box>
                                            <Box p={0.5} display="flex" alignItems="center" justifyContent="space-between">
                                                <Typography variant="h5" fontWeight="bold">
                                                    {/* Quality Certificate Report */}
                                                </Typography>

                                                {/* Container for icons aligned to the right */}
                                                <Box display="flex" alignItems="center" gap={0.5}>
                                                    <Tooltip title="Download Report in PDF">
                                                        <IconButton onClick={handleDownloadPdf} disabled={reportbtndisabled}>
                                                            <DownloadOutlined color="secondary" disabled={reportbtndisabled} />
                                                        </IconButton>
                                                    </Tooltip>

                                                    <Tooltip title="Print Preview">
                                                        <IconButton onClick={handlePrint} disabled={reportbtndisabled}>
                                                            <PrintOutlined color="secondary" disabled={reportbtndisabled} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>



                                            <Box sx={{
                                                borderRadius: "10px",
                                                maxHeight: {
                                                    xs: '72vh', // Extra small devices (phones)
                                                    sm: '72vh', // Small devices (tablets)
                                                    md: '74vh', // Medium devices (small laptops)
                                                    lg: '54vh', // Large devices (desktops)
                                                    xl: '62vh', // Extra large devices (large desktops)
                                                },

                                                overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                                '&::-webkit-scrollbar': {
                                                    width: '8px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: colors.primary[400],
                                                    borderRadius: '10px',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: colors.blueAccent[600],
                                                    borderRadius: '10px',
                                                    '&:hover': {
                                                        background: colors.blueAccent[800],
                                                    },
                                                },
                                                '&::-webkit-scrollbar-corner': {
                                                    background: colors.primary[700],
                                                }
                                            }}>




                                                <QCReportView ref={reportRef} data={allQCData} qcpropertylist={qcpropertylist} />

                                            </Box>
                                        </Box>
                                    </TabPanel>
                                    <TabPanel value="2" sx={{ color: "text.primary", p: 0, m: 0 }}>

                                        <CustomTableContainer colors={colors}>
                                            <Box sx={{ height: 500, width: '100%' }}>
                                                <DataGrid
                                                    rows={rows}
                                                    columns={columnsExisting}
                                                    pageSize={10}
                                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                                    getRowHeight={() => 35} // smaller row height
                                                    disableRowSelectionOnClick

                                                    rowHeight={25}
                                                    slots={{ toolbar: GridToolbar }}
                                                    slotProps={{
                                                        toolbar: {
                                                            showQuickFilter: true,
                                                            quickFilterProps: { debounceMs: 500 },
                                                        },
                                                    }}
                                                />
                                            </Box>
                                        </CustomTableContainer>


                                    </TabPanel>

                                </TabContext>
                            </Box>





                        </>
                    )}

                    {viewPropertymaster && (
                        <AddQCPropertyMaster handleBackWinderMachineEntry={handlePropertyMasterOpenClose} />
                    )}

                </Box>
            </CardContent>


        </Box>

    )
};
export default GenerateQCDataByFilterData;